import requestAxios from "@/helpers/request_axios";
import { orderPaymentStates } from "@/helpers/get_constants";
import * as MutationsType from "./mutationsType";

export default {
  async getCashRegisterById({ commit, state }, { id }) {
    try {
      let cashRegister = state.cashRegister;
      if (!cashRegister || cashRegister.id !== id) {
        let response = await requestAxios({
          url: `/awy/api/v1/ecommerce/cash-registers/${id}`,
          method: "GET",
        });

        cashRegister = response.data.data;
      }

      commit(MutationsType.SET_CASH_REGISTER, cashRegister);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCashRegisters({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/cash-registers",
        method: "GET",
      });
      commit(MutationsType.SET_CASH_REGISTERS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCashRegistersByStore({ commit }, { storeId }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/cash-registers",
        method: "GET",
        params: { store_id: storeId },
      });
      commit(MutationsType.SET_CASH_REGISTERS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCashRegistersByCurrentAgent({ commit, rootState }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/cash-registers",
        method: "GET",
        params: { uid: rootState.Agent.agent.uid },
      });
      commit(MutationsType.SET_CASH_REGISTERS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveCashRegister({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/cash-registers",
        method: "POST",
        data: data,
      });

      if (!state.cashRegisters) commit(MutationsType.SET_CASH_REGISTERS, []);

      commit(MutationsType.ADD_CASH_REGISTER, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateCashRegister({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_CASH_REGISTER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  resetCashRegister({ commit }) {
    commit(MutationsType.SET_CASH_REGISTER, null);
  },
  async openCashRegister({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}/open`,
        method: "POST",
      });
      commit(MutationsType.UPDATE_CASH_REGISTER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async closeCashRegister({ commit }, { id, totals }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}/close`,
        method: "POST",
        data: { totals },
      });
      commit(MutationsType.UPDATE_CASH_REGISTER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async reCloseCashRegister({ commit }, { id, totals, comment }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}/re-close`,
        method: "POST",
        data: { totals, comment },
      });
      commit(MutationsType.UPDATE_CASH_REGISTER, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCashRegisterOrders({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}/orders`,
        method: "GET",
      });
      commit(MutationsType.SET_CASH_REGISTER_ORDERS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCashRegisterOrdersCanceled({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}/orders`,
        method: "GET",
        params: {
          payment_state: orderPaymentStates.CANCELED,
        },
      });
      commit(MutationsType.SET_CASH_REGISTER_ORDERS_CANCELED, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async cancelCashRegisterOrder({ commit, state }, { orderId }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${state.cashRegister.id}/orders/${orderId}/cancel`,
        method: "POST",
      });
      let order = response.data.data;
      commit(MutationsType.DELETE_CASH_REGISTER_ORDER, order);
      commit(MutationsType.ADD_CASH_REGISTER_ORDER_CANCELED, order);
    } catch (error) {
      throw error.response.data;
    }
  },
  async generateCashRegisterReportProducts({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${state.cashRegister.id}/reports/top-products-selled`,
        method: "GET",
      });
      commit(MutationsType.SET_CASH_REGISTER_REPORT_PRODUCTS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async generateCashRegisterReportTotals({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${state.cashRegister.id}/reports/totals`,
        method: "GET",
      });
      commit(MutationsType.SET_CASH_REGISTER_REPORT_TOTALS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getCashRegisterReportsClose({ commit }, { storeId, date }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/cash-registers/reports/close",
        method: "GET",
        params: { date, store_id: storeId },
      });
      commit(MutationsType.SET_CASH_REGISTER_REPORT_CLOSE, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCashRegisterPaymentMethods({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}/payment-methods`,
        method: "GET",
      });
      commit(MutationsType.SET_CASH_REGISTER_PAYMENT_METHODS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getCashRegisterShiftConfig({ commit }, { id, shiftId }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/cash-registers/${id}/shifts/${shiftId}`,
        method: "GET",
      });
      commit(MutationsType.SET_CASH_REGISTER_SHIFT, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  resetCashRegisterPaymentMethods({ commit }) {
    commit(MutationsType.SET_CASH_REGISTER_PAYMENT_METHODS, null);
  },
  resetModuleCashRegister({ commit }) {
    commit(MutationsType.SET_CASH_REGISTER, null);
    commit(MutationsType.SET_CASH_REGISTERS, null);
    commit(MutationsType.SET_CASH_REGISTER_REPORT_PRODUCTS, null);
    commit(MutationsType.SET_CASH_REGISTER_REPORT_TOTALS, null);
    commit(MutationsType.SET_CASH_REGISTER_REPORT_CLOSE, null);
    commit(MutationsType.SET_CASH_REGISTER_PAYMENT_METHODS, null);
  },
};
